require('./bootstrap');

//libs
require('./lib/jquery.min')
require('./lib/jquery.maskedinput.min')
require('./lib/sweetalert.min')
require('./lib/animation')
require('./lib/jquery.fancybox.min')
require('./lib/slick.min')


//modules
require('./modules/common');
require('./modules/core');

